import { Input, useIntl } from 'platform-components';
import { INPUT_SIZES, INPUT_THEMES } from 'platform-components/constants';
import React from 'react';

import { EmailData } from '../typings';

interface Props {
    canChangeData: boolean;
    emailData: EmailData;
}

export const CertificateModalEmail = ({
    canChangeData,
    emailData: { emailErrorMessage, email, handleValidateEmail, handleEmailChange },
}: Props) => {
    const intl = useIntl();

    return (
        <Input
            disabled={!canChangeData}
            errorMessage={emailErrorMessage}
            mix="certificate-modal__form-field"
            onBlur={handleValidateEmail}
            onChange={handleEmailChange}
            placeholder={intl.formatMessage({ id: 'certificatesModal.form.email' })}
            size={INPUT_SIZES.XL}
            theme={INPUT_THEMES.YANDEX}
            valid={emailErrorMessage ? 'no' : 'uncertain'}
            value={email}
        />
    );
};
